export enum ImportStep {
    upload = 0,
    controlColumn = 5,
    outcomeColumn = 10,
    dimensions = 15,
    series = 18,
    cards = 20,
}